import * as Utils from "../utils";

// The `object` param: a field whose value is a whole subform.
//
// `type` names one of the table's SUBFORMS — the `subforms` array on the
// table, declared on the editor's Subforms tab — and types-values compiles
// it as `$ref: /Type/<name>`, exactly as pagews' object param names a sibling
// type in a section's `types`. Not a $ref here: the target does not exist as a
// schema document until generateSchema compiles the table at runtime.
//
// The same shape as pagews' /Types/Param/Type/Object, and kept that way: the
// runtime that reads it is shared.
export const schema = [
  {
    id: "/Types/Param/Type/Object",
    type: "object",
    properties: {
      type: { label: "Subform", type: "string", minLength: 1, default: "" },
      nullable: { label: "Empty by default?", type: "boolean", default: false },
      ...Utils.properties,
    },
    required: ["type"],
  },
];
